import ziperase from '../../services/ziperase';
import { notify } from '../../services/notify';
import config from '../../constants/config';

const requiredFields = [
  { key: 'view_history', label: '', thStyle: { width: '10px' } },
  { key: 'update_status', label: '', thStyle: { width: '10px' } },
]

const optionalFields = [
    { key: 'organization.name', label: 'Organization', sortable: true, sort_key: 'organization.name', thStyle: { width: '80px' } },
    { key: 'latest_result.status', label: 'Autopilot Status', sortable: true, sort_key: 'latest_result.status', thStyle: { width: '80px' }, isDefaultTable: true },
    { key: 'latest_result.updated_at', label: 'Updated At', sortable: true, sort_key: 'latest_result.updated_at', thStyle: { width: '80px' }, isDefaultTable: true },
    { key: 'system_manufacturer', label: 'Vendor', sortable: true, sort_key: 'system_manufacturer', thStyle: { width: '100px' } },
    { key: 'system_product_name', label: 'Model', sortable: true, sort_key: 'system_product_name', thStyle: { width: '100px' } },
    { key: 'system_serial_number', label: 'Serial', sortable: false, sort_key: 'system_serial', thStyle: { width: '100px' } },

]

const state = {
    enrollments: null,
    enrollment: null,
    count: 0,
    selectedFields: optionalFields,
    filter: null,
    sortBy: null,
    sortDesc: null,
    perPage: config.DEFAULT_PER_PAGE,
    searchQuery: '',
    statusFilter: [],
  }

const mutations = {
    enrollments(state, enrollments) {
        state.enrollments = enrollments;
    },
    enrollment(state, enrollment) {
        state.enrollment = enrollment;
    },
    count (state, count) {
      state.count = count;
    },
    selectedFields (state, selectedFields) {
      state.selectedFields = selectedFields;
    },
    filter (state, filter) {
      state.filter = filter;
    },
    sortBy (state, sortBy) {
      state.sortBy = sortBy;
    },
    sortDesc (state, sortDesc) {
      state.sortDesc = sortDesc;
    },
    perPage (state, perPage) {
      state.perPage = perPage;
    },
    searchQuery (state, searchQuery) {
      state.searchQuery = searchQuery;
    },
    statusFilter (state, filter) {
      state.statusFilter = filter;
    },
}

const getters = {
    enrollments: () => state.enrollments,
    enrollment: () => state.enrollment,
    count: () => state.count,
    optionalFields: () => state.optionalFields,
    selectedFields: () => state.selectedFields,
    tableFields: () => {
        return [...state.selectedFields, ...requiredFields];
    },
    filter: () => state.filter,
    sortBy: () => state.sortBy,
    sortDesc: () => state.sortDesc,
    perPage: () => state.perPage,
    searchQuery: () => state.searchQuery,
    statusFilter: () => state.statusFilter,
    fetchParams: (state) => {
      let params = {};

      if (state.sortBy) {
        let sortField = optionalFields.find(field => {
          return state.sortBy == field.key;
        });
        params.sort_by = sortField.sort_key || sortField.key;
      }

      if (state.sortDesc !== null) {
        params.sort_desc = state.sortDesc;
      }

      if (state.searchQuery) {
        params.search = state.searchQuery;
      }
      if (state.filter) {
        params = { ...params, ...state.filter };
      }

      return params;
    }
}

const actions = {
    async fetchEnrollments({ commit, getters }, params) {
      try {
        let fetchParams = { ...getters.fetchParams };
        Object.keys(params).forEach(key => fetchParams[key] = params[key]);
        if (getters.statusFilter !== null && getters.statusFilter.length > 0) {
          fetchParams['status'] = getters.statusFilter.map(e => e.value);
        }

        const response = await ziperase.fetchEnrollments(fetchParams);
        commit('enrollments', response.data.data.map(item => {
          item.isSelected = false;
          return item;
        }));
        commit('count', response.data.pagination.count);
      } catch (err) {
        console.log(err);
        notify().error('Error! Failed to get enrollments.');
      }
    },
    async fetchEnrollment({ commit }, id) {
      try {
        const response = await ziperase.fetchEnrollment(id);
        commit('enrollment', response.data);
      } catch (err) {
        console.log(err);
        commit('enrollment', null);
        notify().error('Error! Failed to get enrollment.');
      }
    },
    async autopilotImport({ commit }, enrollment) {
        let response;
        try {
            response = await ziperase.autopilotImport(enrollment);
        }
        catch (err) {
            console.log(err);
            throw new Error('Error! Failed to update enrollment status.');
        }
        if (response.data.id === null) {
          throw new Error('Error! No Autopilot licenses left.');
        }
    },
    async autopilotReimport({ commit }, enrollmentId) {
        let response;
        try {
            response = await ziperase.autopilotReimport(enrollmentId);
        }
        catch (err) {
          console.log(err);
          throw new Error('Error! Failed to update enrollment status.');
        }
        if (response.data.id === null) {
          throw new Error('Error! No Autopilot licenses left.')
        }
      },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
  }
